
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"16","height":"16"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M0 0h16v16H0z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M13.567 13.6l-3.417-3.417a4.84 4.84 0 01-1.358.75A4.669 4.669 0 017.2 11.2c-1.044 0-1.978-.297-2.8-.892A4.636 4.636 0 012.683 8H4c.3.6.733 1.083 1.3 1.45.567.367 1.2.55 1.9.55 1 0 1.85-.35 2.55-1.05.7-.7 1.05-1.55 1.05-2.55 0-1-.35-1.85-1.05-2.55-.7-.7-1.55-1.05-2.55-1.05-.867 0-1.62.267-2.258.8a3.63 3.63 0 00-1.242 2H2.467a4.67 4.67 0 011.608-2.858C4.958 1.98 6 1.6 7.2 1.6c1.333 0 2.467.467 3.4 1.4.933.933 1.4 2.067 1.4 3.4a4.683 4.683 0 01-1 2.933l3.4 3.417-.833.85zM6.483 8.8L5.6 5.25 5.117 7.2H.8v-.8h3.683l.6-2.4h1.034l.9 3.65.7-2.05h.933l.8 1.6H10V8H8.95l-.717-1.433-.75 2.233h-1z","fill":"#2962FF"}})])])
          )
        }
      }
    